
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  getComparisonDateRange,
  getPopDescription,
} from '@bingads-webui-campaign/overview-cards-common';
import { HelpButton } from '@bingads-webui-react/help-popup';
import GridMetricPicker from './grid-metric-picker';
import GridPicker from './grid-metric-picker-fluent';

function GridHeader(props) {
  const {
    dateRange,
    i18n,
    permissions,
  } = props;

  const comparisonDateRange = useMemo(
    () =>
      getComparisonDateRange(dateRange),
    [dateRange]
  );

  const popDescription = useMemo(
    () =>
      getPopDescription(i18n, comparisonDateRange),
    [i18n, comparisonDateRange]
  );

  const requiredPermission = permissions.dynamic.OverviewPageFluentV2 || permissions.dynamic.OverviewPageFluent2;

  return (
    <div className="conversion-tracking-grid-header">
      <div className="popComparisonRange">
        {popDescription}
        <HelpButton
          aria-label={popDescription}
          topic="pop_BA_Overview_TopChangesDateRange"
        />
      </div>

      {requiredPermission ? <GridPicker {...props} /> : <GridMetricPicker {...props} /> }
    </div>
  );
}

GridHeader.defaultProps = {
};
GridHeader.propTypes = {
  dateRange: PropTypes.shape({
    RangeEndDate: PropTypes.string,
    RangeStartDate: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
  }).isRequired,
  newI18n: PropTypes.shape({
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      OverviewPageFluentV2: PropTypes.bool,
      OverviewPageFluent2: PropTypes.bool,
    }),
  }).isRequired,
};

export default GridHeader;
